import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as MySVG } from "./sig.svg"; // Import SVG as a component
import "./SignatureAnimation.css";

function SignatureAnimation({ className }) {
  const [lengths, setLengths] = useState({}); // Store path lengths in state
  const svgRef = useRef(null);

  useEffect(() => {
    if (svgRef.current) {
      const paths = svgRef.current.querySelectorAll("path, circle");
      const newLengths = {};
      paths.forEach((path) => {
        const pathId = path.id;
        const length = path.getTotalLength();
        if (pathId) {
          // Only add if ID exists
          newLengths[pathId] = length;
        }
      });
      setLengths(newLengths); // Update state with the lengths
    }
  }, []); // Run only once, after initial render

  return (
    <div className={`signature-container ${className || ""}`}>
      <MySVG
        ref={svgRef}
        className="animate"
        style={{
          "--evey-length": lengths.evey ? lengths.evey + "px" : "0px", // Add fallback
          "--grif-length": lengths.grif ? lengths.grif + "px" : "0px",
          "--t_cross-length": lengths.t_cross ? lengths.t_cross + "px" : "0px",
          "--i_dot-length": lengths.i_dot ? lengths.i_dot + "px" : "0px",
        }}
      />
    </div>
  );
}

export default SignatureAnimation;
